module.exports = __webpack_public_path__ + "static/media/maxParties_100_150.55be112b.png";